import ProductIncludedExcluded from '@/features/accommodation/ui/ListItemContent/IncludedExcluded';
import { useSlotState } from '@/features/product/hooks/useSlotState';
import ProductListItemContentErrorBoundary from '@/features/product/ui/ErrorBoundary';
import ProductOptionGroup from '@/features/product/ui/OptionGroup';
import ProductQuantity from '@/features/product/ui/Quantity';
import ProductSelectDate from '@/features/product/ui/SelectDate';
import ProductTotal from '@/features/product/ui/Total';

import SlotOption from './SlotOption';

interface IProps {
  idx: string;
  shouldShow: boolean;
}
export default function SlotListItemContent({ idx, shouldShow }: IProps) {
  return (
    <ProductListItemContentErrorBoundary>
      <ContentBoundary idx={idx} shouldShow={shouldShow} />
    </ProductListItemContentErrorBoundary>
  );
}

function ContentBoundary({
  idx,
  shouldShow,
}: Omit<IProps, 'selectedIdx' | 'isExpanded'> & { shouldShow: boolean }) {
  const {
    t,
    slotData,
    slotDateList,
    slotBoxList,
    showSlotBoxListLoading,

    currentMonth,
    selectedDate,
    handleDateClick,
    handleChangeMonth,

    slotOptionQuantity,
    handleUpdateSlotOptionQuantity,
    selectedSlotOptionList,
    handleSelectSlotOption,

    selectedOptionGroupList,
    handleSelectOption,

    totalAmount,

    addSlot,
  } = useSlotState(idx, shouldShow);

  return (
    <>
      <ProductIncludedExcluded included={slotData?.included} excluded={slotData?.excluded} />

      <ProductSelectDate
        currentMonth={currentMonth}
        selectedDate={selectedDate}
        slotDateList={slotDateList}
        availableStartDate={slotDateList?.[0]?.date}
        availableEndDate={slotDateList?.[slotDateList.length - 1]?.date}
        handleDateClick={handleDateClick}
        handleChangeMonth={handleChangeMonth}
      />

      {selectedDate && (
        <div className='relative'>
          <SlotOption
            slotOptionTitle={slotData?.slotOptionTitle}
            slotOptionList={slotBoxList}
            selectedSlotOptionList={selectedSlotOptionList}
            handleSelectSlotOption={handleSelectSlotOption}
          />
          {showSlotBoxListLoading && (
            <div className='absolute inset-0 flex items-center justify-center bg-background/80 backdrop-blur-sm'>
              <div className='flex items-center gap-2 text-sm text-muted-foreground'>
                <div className='h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent' />
              </div>
            </div>
          )}

          <ProductOptionGroup
            optionGroupList={slotData?.optionGroupList}
            selectedOptionGroupList={selectedOptionGroupList}
            handleSelectOption={handleSelectOption}
          />

          {selectedSlotOptionList.length > 0 && (
            <ProductQuantity
              title={t('quantity')}
              quantityName={selectedSlotOptionList[0].title || t('quantity')}
              quantityDescription={
                selectedSlotOptionList[0].type === 'PER_PERSON' ? t('perPerson') : ''
              }
              quantity={slotOptionQuantity}
              updateQuantity={handleUpdateSlotOptionQuantity}
              maxQuantity={selectedSlotOptionList[0].availableCount}
              maxQuantityDescription={t('maxPurchaseCount')}
              price={selectedSlotOptionList[0].price}
              isRequired
            />
          )}
        </div>
      )}

      <ProductTotal totalAmount={totalAmount} addItemLabel={t('add')} addItem={addSlot} />
    </>
  );
}
